import React from "react";
import ReactEcharts from "echarts-for-react";
import { echartOptions } from "@gull";
const LineChart3 = ({ height, data = [], categories = [] }) => {
  const option = {
    ...echartOptions.lineSplitNoAxis,
    tooltip: {
      trigger: "axis",
      backgroundColor: "rgba(0, 0, 0, .8)",
    },
    xAxis: {
      ...echartOptions.lineSplitNoAxis.xAxis,
      data: categories,
      axisLabel: {
        show: categories.length > 0,
        interval: 2,
        rotate: 35,
      },
    },
    grid: {
      top: 15,
      left: 15,
      right: 15,
      bottom: categories.length > 0 ? 40 : 0
    },
    series: [
      {
        data: data,
        lineStyle: {
          color: "rgba(112, 191, 106, 0.8)",
          width: 3,
          ...echartOptions.lineShadow
        },
        label: { show: true, color: "#212121" },
        type: "line",
        smooth: true,
        itemStyle: {
          borderColor: "rgba(102, 51, 153, 1)"
        }
      }
    ]
  };

  return <ReactEcharts style={{ height: height }} option={option} />;
};

export default LineChart3;
